import React from 'react';
import { Button, SimpleGrid, Stack, Text, TextInput } from '@mantine/core';
import FlowAlert from '@/components/auth/flow/components/parts/Flow.Alert';
import personNameClean, { PERSON_NAME_MAX } from '@/function/auth/person.name.clean';
import type { TypeFlowScreenProps } from '@/types/auth/types.auth.flow';

type Props = TypeFlowScreenProps & { step: string };

type Errors = { firstname?: string; lastname?: string };

const FlowProfile: React.FC<Props> = ({ flow, message, step }) => {
    const [values, setValues] = React.useState({ firstname: '', lastname: '' });
    const [errors, setErrors] = React.useState<Errors>({});
    const serverField = message?.field === 'firstname' || message?.field === 'lastname' ? message.field : null;

    const submit = (event: React.FormEvent) => {
        event.preventDefault();
        if (flow.busy) return;
        const firstname = values.firstname.trim();
        const lastname = values.lastname.trim();
        const next: Errors = {};
        if (!firstname) next.firstname = 'Il nome è obbligatorio';
        if (!lastname) next.lastname = 'Il cognome è obbligatorio';
        setErrors(next);
        if (next.firstname || next.lastname) return;
        void flow.submit(step, { firstname, lastname, locale: 'it' });
    };

    const errorOf = (key: 'firstname' | 'lastname'): string | undefined => errors[key] ?? (serverField === key ? message?.text : undefined);

    const change = (key: 'firstname' | 'lastname') => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = personNameClean(event.currentTarget.value);
        setErrors((current) => ({ ...current, [key]: undefined }));
        setValues((current) => ({ ...current, [key]: value }));
    };

    return (
        <form onSubmit={submit} noValidate>
            <Stack gap="15px">
                <FlowAlert message={serverField ? null : message} />
                <Text size="sm" c="dimmed">Come ti chiami? Il nome compare nella dashboard e nelle attività che registri.</Text>
                <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="sm">
                    <TextInput withAsterisk label="Nome" placeholder="Mario" autoComplete="given-name" maxLength={PERSON_NAME_MAX} data-autofocus value={values.firstname} error={errorOf('firstname')} onChange={change('firstname')} />
                    <TextInput withAsterisk label="Cognome" placeholder="Rossi" autoComplete="family-name" maxLength={PERSON_NAME_MAX} value={values.lastname} error={errorOf('lastname')} onChange={change('lastname')} />
                </SimpleGrid>
                <Button type="submit" radius="md" loading={flow.busy} disabled={flow.busy}>CONTINUA</Button>
            </Stack>
        </form>
    );
};

export default FlowProfile;
